import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-at",
  "use": "icon-flag-at-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-at\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 860.16h1024V184.32H0z\" fill=\"#ED2939\" p-id=\"12812\" /><path d=\"M0 634.88h1024V409.6H0z\" fill=\"#FFFFFF\" p-id=\"12813\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-at.svg
// module id = SuRi
// module chunks = 24